import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import DOMPurify from "dompurify";


const ProductRatting = ({ productData }: any) => {

    return (
        <React.Fragment>
            <Row>
                <Col lg={12}>
                    <Card>
                        <div className={"container"}>
                            <Card.Header className="mb-2">
                                <Card.Title className="flex-grow-1 mb-0">Description</Card.Title>
                                <hr />
                            </Card.Header>
                            <Card.Body>
                                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(productData.description) }}
                                    className={"description_content"} />
                            </Card.Body>
                        </div>

                    </Card>
                   
                </Col>
            </Row>

        </React.Fragment>
    );
}

export default ProductRatting;